import React from "react";
import styles from "./CoreItem.module.scss";
import cx from "classnames";
import CoreItem from "./CoreItem";
import { usePageContext } from "@providers/PageProvider";
import { aboutUsPage } from "@utils/helper";
import _ from "lodash";
export default function CoreValues() {
  const { pageData } = usePageContext();
  const coreValues = aboutUsPage.formatCoreValues(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center", styles.coreValuesSection)}
    >
      <div className={cx(styles.title)}>
        {_.get(coreValues, "title", "")}
      </div>
      <div className={cx(styles.coreItemsWrapper)}>
        {coreValues.coreValues.map((value, index) => (
          <CoreItem key={index} data={value} />
        ))}
      </div>
    </div>
  );
}
